module.exports = __webpack_public_path__ + "img/logo.9334c410.png";